
<mat-card style="margin: 16px; height: 80%">
    <mat-card-content style="height: 90%">
        Click to start and then use the mouse to create a rectangle that has the same size as a credit card.

        <canvas #canvas width="100" style="width: 100%; height: 100%;" (click)="canvasClick($event)"></canvas>
    </mat-card-content>
    <mat-card-actions>
        <button *ngIf="showContinue" mat-raised-button color="primary" (click)="continueButton()">Continue</button>
    </mat-card-actions>
</mat-card>
